import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { AppNotifications } from '../../core/AppNotifications';

export const BoxNotification = styled(AppNotifications)`
  display: none;
  height: 100vh;
  margin: ${rem('44px')} 0 0 0;
  position: absolute;
  right: -3.7rem;
  top: 0;
  width: 100vw;

  ${props =>
    props.show &&
    `display: block;
  `};

  ${mediaqueries.greaterThan('mobile')`
    height: auto;
    margin: ${rem('70px')} 0 0 0;
    right: -6.5rem;
    width: ${rem('612px')};
    background-color: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.dark};
  `};

  ${mediaqueries.between('mobile', 'tablet')`
    &:before {
      background-color: ${props => props.theme.colors.light};
      color: ${props => props.theme.colors.dark};
      content: '';
      height: 100%;
      left: 0;
      opacity: 0.7;
      position: fixed;
      top: ${rem('69px')};
      width: 100%;
      z-index: -1;
    }  
  `};

  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.dark};
    margin: 3.5rem 0 0 0;
    right: 0;
    width: ${rem('1224px')};
  `};
`;
